export enum KickbackSource {
  VIVA = "VIVA",
  PAYTRIM = "PAYTRIM",
  ELAVON = "ELAVON",
}

export const KICKBACK_REPORT_SOURCES = [
  KickbackSource.PAYTRIM,
  KickbackSource.ELAVON,
] as const;

export type KickbackReportSource = (typeof KICKBACK_REPORT_SOURCES)[number];
